export default {
  pages: {
    registrationComplete: {
      header: 'Спасибо! Скоро наши менеджеры свяжуться с вами',
      pleaseWait: 'Пожалуйста, подождите пока наши менеджеры свяжуться с вами и мы откроем вам доступ в нашу систему!',
      ok: 'Понятно',
    },
  },
};
